module.exports = __webpack_public_path__ + "assets/img/mall-jietu.4686fe68.png";